module.exports = __webpack_public_path__ + "media/application/images/2018/rd-2020-powerswitch-cc110e65321e2d9bf4c120a7bbf73ad2.png";